



















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { Garage } from "@/entity/Garage";
import GarageAttachmentDetails from '@/components/GarageAttachmentDetails.vue'
import GarageSigns from '@/components/GarageSigns.vue'
import { DropDownItem } from "@/services/DropDownItem";
import { GarageAttachment } from "@/entity/GarageAttachment";
import AddDropDown from "@/components/Utilities/AddDropDown.vue";  


@Component({
  components: {
    GarageAttachmentDetails,
    GarageSigns,
    AddDropDown
  }
})
export default class GarageDetails extends Vue {
  @Prop({ type: Boolean, required: false })
  editMode;
  @Prop({ type: String, required: false })
  idGarage;
  @Prop({ type: Array, required: true })
  optionsGarageTypesProp: [];
  @Prop({ type: Boolean, required: true })
  firstSearch;


  test: string="";

  parentMounted: boolean = false;
  loading: boolean = false;
  garage: Garage = new Garage();
  optionsGarageTypes = new Array();
  optionsDelegates: any = new Array();
  optionsCfl: any = new Array();
  tabActivated: number = 0;
  isSaveClicked: boolean = false;

  attachmentToBeChanged = new Array<GarageAttachment>();
  attachmentToSave = new Array<GarageAttachment>();

  DELEGATES_SOURCE = "SIGNS_DELEGATES";
  CFL_SOURCE = "SIGNS_CFL";

  async mounted() {
    this.tabActivated = 0;
    this.loading = true;
    this.optionsGarageTypes = this.optionsGarageTypesProp;
    this.optionsDelegates = await this.getDropDownListBySourceCode(this.DELEGATES_SOURCE);
    this.optionsCfl = await this.getDropDownListBySourceCode(this.CFL_SOURCE);
    if(this.idGarage != null) {
      await this.getGarageById(this.idGarage);
    } else {
      this.loading = false; 
      this.garage.attachments = new Array<GarageAttachment>();
      this.parentMounted = true;
    }
  }

  returnState(condition: boolean, clickButton: boolean): boolean {
    if (clickButton) 
      return condition;
    else 
      return null;
  }

  toBool(a: any) {
    var converted = false;
    if(a === undefined || a === "" || a == null) {
      converted =  false;
    }
    else {
      if(a === "true")
        converted = true;
    }
    return converted
  }

  async getDropDownListBySourceCode(sourceCode: string) : Promise<Array<any>>{
    try{
        let response = await axios.get<DropDownItem[]>(
            General.GetApiUrl('/api/DropDownItem/GetDropDownItemsBySourceCode?codDropDownSource=' + sourceCode),{
            responseType: "json",
            withCredentials: true
        });
    if(response.data)
        return this.setOptions(response.data);
    }catch(ex){
        General.HandleError(ex, this);
        return null;
    }
  }

  setOptions(dropDownItems: DropDownItem[]) {
    let array: Array<any> = [];

    array.push({ value: null, text: "" });


    dropDownItems.forEach(function (el) {
    array.push({ value: el.idDropDownItem, text: el.itemText });
    });
    return array;
  }

  async getGarageById(idGarage: string) {
    try {
      let response = await axios.get<any>(
        General.GetApiUrl("/api/Sign/GetGarageById?garageId=" + this.idGarage),
        {
          withCredentials: true,
        }
      );
      this.garage = response.data;
      this.loading = false;
      this.parentMounted = true;
    } catch (error) {
      General.HandleError(error, this);
      this.parentMounted = false;
    }
  }

  async addOrUpdate(garage: Garage) {
    this.isSaveClicked = true;
    if((garage.piva === '' || garage.piva == null) && (garage.cf === '' || garage.cf == null)) {
      General.showAlertDanger("Compilare almeno un campo tra Partita Iva o Codice Fiscale", this);
    } else {
      if((!garage.cfl && this.toBool(garage.flagBo)) || !garage.rascl) {
        General.showAlertDanger("Verificare campi obbligatori", this);
      } else {
        if(this.editMode) {
          await this.updateGarageDo(garage);
        } else {
          await this.insertGarageDo(garage);
        }
      }
    }
  }

  async updateGarageDo(garage: Garage) {
    garage.attachments = this.getAttachmentsToSave();
    General.confirm(
      "Confermi di voler aggiornare l'officina con Codice PLI " + garage.codiceFl + "?",
      this,
      async () => {
        await this.updateGarage(garage);
      }
    );
  }

  async updateGarage(garage: Garage) {
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/sign/UpdateGarage"),
        data: garage,
        withCredentials: true,
        responseType: "json",
      });
      General.showAlertSuccess("Officina aggiornata", this);
      this.isSaveClicked = false;
      this.closeDetailModal();
      if (this.firstSearch) 
        this.$emit("garage-search");
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  async insertGarageDo(garage: Garage) {
    garage.attachments = this.getAttachmentsToSave();
    General.confirm(
      "Confermi di voler creare l'officina?",
      this,
      async () => {
        await this.insertGarage(garage);
      }
    );
  }

  async insertGarage(garage: Garage) {
    try {
      this.loading = true;
      let response = await axios.post(General.GetApiUrl('/api/sign/CreateGarage'),garage,{ withCredentials: true });
      if(response.data != null) {
        let garageCodiceFl: string = response.data;
        General.showAlertSuccess("Officina creata", this);
        this.isSaveClicked = false;
        this.closeDetailModal();
        this.$emit("garage-created", garageCodiceFl);
      }
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  getAttachmentsToSave() : Array<GarageAttachment> {
    return this.attachmentToSave.filter((a) => !a.toDelete || (a.toDelete && a.id != null));
  }

  closeDetailModal() {
    this.$bvModal.hide("garage-details-modal");
  }

  removeAttachment(attachment: GarageAttachment){
    this.attachmentToSave.forEach(el=>{
        if (attachment.sessionId != null && el.sessionId==attachment.sessionId)
            el.toDelete = true;
    });

    if (!this.attachmentToSave.find(el=>el.sessionId==attachment.sessionId)||attachment.sessionId==null)
        attachment.toDelete = true;
        this.attachmentToSave.push(attachment);
  }

  setAttachment(attachment: GarageAttachment){
    attachment.id = null;
    attachment.toDelete = false;
    this.attachmentToSave.push(attachment);
  }
  async insertItemDone(e){
    

    let options = await this.getDropDownListBySourceCode(e.dropDownSource);

    

    switch(e.dropDownSource){
      case "SIGNS_CFL":{
        this.optionsCfl = options;
        this.garage.cfl = e.id;
        break;
      }
      
      case this.DELEGATES_SOURCE:{        
        this.optionsDelegates = options;
        this.garage.incaricato = e.id;
        break;
      }
    }
  }
}
